import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useGAPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const timeoutId = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [location]);
};

export const trackLoginSuccess = (userId, method) => {
  if (!window.gtag) return;
  window.gtag("config", "G-WD8PPX0DY9", {
    user_id: userId,
  });
  window.gtag("event", "login", {
    method: method,
  });
};

export const trackCommentCreated = ({
  entityType,
  entityId,
  level,
  visibility,
  mentionedUsersCount,
  commentLength,
}) => {
  if (!window.gtag) return;
  window.gtag("event", "comment_created", {
    entity_type: entityType,
    entity_id: entityId,
    level: level,
    visibility: visibility,
    mentioned_user_count: mentionedUsersCount,
    has_mentions: mentionedUsersCount > 0,
    comment_length: commentLength,
  });
};

export const trackAdvancedSearch = ({
  resultType,
  searchType,
  selectedAttributes,
  additionalOptions,
  hasFiltersApplied,
}) => {
  if (!window.gtag) return;

  window.gtag("event", "advanced_search", {
    result_type: resultType
      ? resultType.toLowerCase().replace(/\s+/g, "_")
      : "unknown",
    search_type: searchType || "execute",
    attributes_selected: selectedAttributes,
    attributes_selected_count: selectedAttributes.length,
    additional_options: additionalOptions,
    additional_options_count: additionalOptions.length,
    filters_applied: hasFiltersApplied,
  });
};

export const trackSaveQuery = ({ queryId, description, outcome }) => {
  if (!window.gtag) return;

  window.gtag("event", "save_query", {
    query_id: queryId || "new",
    description: description || "none",
    outcome,
  });
};
